import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Translate, CaretDown } from '@phosphor-icons/react';
import { supportedLanguages } from '../i18n';

export default function LanguageSwitcher({ compact = false, dropUp = false }) {
  const { i18n, t } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const close = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('click', close);
    return () => document.removeEventListener('click', close);
  }, []);

  const current = supportedLanguages.find((l) => l.code === i18n.language) || supportedLanguages[0];

  const change = (code) => {
    i18n.changeLanguage(code);
    try { localStorage.setItem('stockaris_lang', code); } catch (e) { /* ignore */ }
    setOpen(false);
  };

  return (
    <div className="relative" ref={ref}>
      <button
        onClick={() => setOpen(!open)}
        data-testid="language-switcher"
        className={`inline-flex items-center gap-1 ${compact ? 'px-2 py-1 text-xs' : 'px-3 py-1.5 text-sm'} border border-border bg-card text-foreground hover:bg-accent font-semibold uppercase tracking-widest rounded-md transition-colors`}
        title={t('common.language', 'Language')}
      >
        <Translate size={compact ? 12 : 14} />
        <span className="font-mono">{current.flag}</span>
        <CaretDown size={compact ? 10 : 12} />
      </button>
      {open && (
        <div
          className={`absolute end-0 min-w-[140px] border border-border bg-popover text-popover-foreground shadow-lg z-50 rounded-md ${dropUp ? 'bottom-full mb-1' : 'top-full mt-1'}`}
          data-testid="language-dropdown"
        >
          {supportedLanguages.map((l) => (
            <button
              key={l.code}
              onClick={() => change(l.code)}
              data-testid={`lang-option-${l.code}`}
              className={`w-full text-left px-3 py-2 text-sm flex items-center justify-between ${i18n.language === l.code ? 'bg-brand text-brand-foreground' : 'hover:bg-accent'}`}
            >
              <span>{l.label}</span>
              <span className="font-mono text-xs opacity-60">{l.flag}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
